// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"b77abe1b","371":"ad9b43a2","488":"0ef0667a","839":"4756ac4a"}[chunkId] + ".chunk.js";
};